import { actions } from '..';
import * as apiQueue from '../../api/queue-control';
import { all } from 'async-saga';
import { takeEvery } from '../tools/async-saga-types';

const fetchOutboundCodes = takeEvery(actions.fetchOutboundCodesRequest, async function (ctx, { mediaItemId, campaignId }) {
  const codes = await apiQueue.getOutboundCodes(mediaItemId, campaignId)

  ctx.dispatch(actions.fetchOutboundCodeResponse(mediaItemId, codes))
})

const fetchOutboundDetailsRequest = takeEvery(actions.fetchOutboundDetailsRequest, async function (ctx, { mediaId, mediaItemId }) {
  const out = await apiQueue.requestOutboundtData(mediaId, mediaItemId)

  ctx.dispatch(actions.fetchOutboundDetailsResponse(out))
})

export default all(
  fetchOutboundCodes,
  fetchOutboundDetailsRequest,
)
